import React, { useState } from "react";

function MorthProjectKn() {
  const [currentTab, setCurrentTab] = useState("RFP");
  return (
    <div className="body-content">
      <div class="letters-color-section">
        <div class="main_header_space">MoRTH ಅಸಿಸ್ಟೆಡ್ VTMS & PIS ಯೋಜನೆ</div>
        <div class="bottom-highlight">
          <span
            className={`${currentTab == "RFP" ? "border-highlight" : ""}`}
            onClick={() => setCurrentTab("RFP")}
          >
            RFP
          </span>
          <span
            className={`${
              currentTab == "Ammendment" ? "border-highlight" : ""
            }`}
            onClick={() => setCurrentTab("Ammendment")}
          >
            Ammendment
          </span>
        </div>

        {currentTab == "RFP" && (
          <div class="main-container">
            <div class="main-header">
              <div class="report-item-list-rfp">
                <ol>
                  <li>ಕಾರ್ಯಾತ್ಮಕ ಮತ್ತು ತಾಂತ್ರಿಕ ಅವಶ್ಯಕತೆಗಳು</li>
                  <li>ಸಾಮಾನ್ಯ ಸೂಚನೆ ಮತ್ತು ವಾಣಿಜ್ಯ ವಿಶೇಷಣಗಳು</li>
                  <li>ಕಾರ್ಯಾಚರಣೆ ಮತ್ತು ಕಾನೂನು ಅವಶ್ಯಕತೆಗಳು</li>
                </ol>
              </div>
            </div>
          </div>
        )}

        {currentTab == "Ammendment" && (
          <div class="main-container">
            <div class="main-header">
              <div class="report-item-list-rfp">
                <ol>
                  <li>VTMS Ammendement 1</li>
                  <li>VTMS Ammendement 2</li>
                  <li>VTMS Ammendement 3</li>
                </ol>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MorthProjectKn;
